import { Component, OnInit, Input, Inject, PLATFORM_ID, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';

@Component({
  selector: 'app-banner-logo-array',
  templateUrl: './banner-logo-array.component.html',
  styleUrls: ['./banner-logo-array.component.scss']
})
export class BannerLogoArrayComponent implements OnInit, AfterViewInit {
  @Input() rendering: ComponentRendering;
  @ViewChild('BannerLogoArraySlider', { static : false}) swiperSlider!: ElementRef;
  dynamicClass: string;
  jssStylingService: JssStylingService;
  devicedetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  swiper: Swiper;
  _isPlatformServer: boolean = false;

  constructor(jssStylingService: JssStylingService, devicedetectorService: CustomDeviceDetectorService,@Inject(PLATFORM_ID) public readonly platformId: string,) { 
    this.jssStylingService = jssStylingService;
    this.devicedetectorService = devicedetectorService;
    platformId 
  }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    // remove this after implementation is done
    console.log('bannerLogoArray component initialized with component data', this.rendering);    
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.isMobile = this.devicedetectorService.isMobile();
  }

  ngAfterViewInit() {
    if(!this._isPlatformServer && this.isMobile){
      this.swiper = new Swiper(this.swiperSlider.nativeElement, {
        spaceBetween: 20,
        freeMode: true,
        grabCursor: true,
        centeredSlides: false,
        slidesPerView: 'auto',
      });
    }
  }
}
